import { useEffect, useState } from 'react';

const shouldPlay = () => {
  if (typeof window === 'undefined' || window.location.hash || window.scrollY > 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  return true;
};

export const useHeroIntro = imageRef => {
  const [phase, setPhase] = useState(() => shouldPlay() ? 'loading' : 'done');
  useEffect(() => {
    if (phase !== 'loading') return;
    let disposed = false;
    const timers = new Set();
    const later = (fn, ms) => { const id = window.setTimeout(fn, ms); timers.add(id); return id; };
    const finish = () => { if (!disposed) setPhase('done'); };
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const keyboard = event => { if (['Tab', 'Escape', 'PageDown', 'ArrowDown', ' '].includes(event.key)) finish(); };
    const changed = () => { if (preference.matches) finish(); };
    const image = imageRef.current;
    const asset = image && window.innerWidth >= 768 ? image.decode().catch(() => {}) : Promise.resolve();
    const minimum = new Promise(resolve => later(resolve, Math.max(0, 450 - (window.__fokeevBootStarted ? performance.now() - window.__fokeevBootStarted : 0))));
    const maximum = new Promise(resolve => later(resolve, 1600));
    Promise.race([Promise.all([asset, minimum]), maximum]).then(() => {
      if (disposed) return;
      setPhase(current => current === 'loading' ? 'playing' : current);
      later(finish, window.innerWidth >= 768 ? 1900 : 850);
    });
    document.addEventListener('keydown', keyboard);
    window.addEventListener('wheel', finish, { passive: true, once: true });
    window.addEventListener('touchstart', finish, { passive: true, once: true });
    preference.addEventListener('change', changed);
    return () => {
      disposed = true;
      timers.forEach(clearTimeout);
      document.removeEventListener('keydown', keyboard);
      window.removeEventListener('wheel', finish);
      window.removeEventListener('touchstart', finish);
      preference.removeEventListener('change', changed);
    };
    // The complete sequence owns one mount, not each phase transition.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return phase;
};
